import { render, staticRenderFns } from "./MassiveFileLoader.vue?vue&type=template&id=60d880ba&"
import script from "./MassiveFileLoader.vue?vue&type=script&lang=js&"
export * from "./MassiveFileLoader.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports